"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoBindMethods = function (obj, ignoredMethods) {
    var currentPrototype = Object.getPrototypeOf(obj);
    while (currentPrototype && currentPrototype.constructor !== Object) {
        for (var _i = 0, _a = Object.keys(currentPrototype); _i < _a.length; _i++) {
            var key = _a[_i];
            var prop = currentPrototype[key];
            if (typeof prop === "function" && (!ignoredMethods || !ignoredMethods.has(key))) {
                obj[key] = prop.bind(obj);
            }
        }
        currentPrototype = Object.getPrototypeOf(currentPrototype);
    }
};
